import React, { useState } from 'react'

export type Breadcrumb = {
  label: string
  path: string
}

export type BreadcrumbsContextType = {
  crumbs?: Breadcrumb[]
  setCrumbs: (label?: Breadcrumb[]) => void
}

export const BreadcrumbsContext = React.createContext<BreadcrumbsContextType | undefined>(undefined)

interface BreadcrumbsContextProviderProps {
  children: React.ReactNode
}

export default function BreadcrumbsContextProvider({ children }: BreadcrumbsContextProviderProps) {
  const [crumbs, setCrumbs] = useState<Breadcrumb[]>()

  return <BreadcrumbsContext.Provider value={{ crumbs, setCrumbs }}>{children}</BreadcrumbsContext.Provider>
}
